import styled from "styled-components";

export const SidebarContainer = styled.div`
  color: #fff;
	background: #1a202c;
  position: fixed;
  width: 255px;
  height: 100%;
  font-weight: 300;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
  border-right: 1px solid #f2f4f7;

  .active {
		border-left: 6px solid #03a9f4;
    color: #03a9f4;
	}

  .profile {
    margin-top: 230px;
    padding: 10px 15px;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    .circled {
      background-color: #03a9f4;
      border-radius: 50%;
      padding: 10px;
      font-size: 20px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      height: 40px;
    }
    .texts {
      margin-top: 5px;
      flex: 1;
      margin-left: 10px;
      h3 {
        font-size: 16px;
        text-transform: capitalize;
      }
      p {
        font-size: 12px;
      }
    }
    .logout {
      cursor: pointer;
      font-size: 20px;
      color: #fff;
      transition: color 0.3s ease;
      &:hover {
        color: #03a9f4;
      }
    }
  }
`;

export const LogoContainer = styled.div`
  padding-left: 30px;
  margin-top: 30px;

  Link {
    text-decoration: none;
  }

  h1 {
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    span {
      color: #03a9f4;
    }
  }
`;

export const Menu = styled.div`
  margin-top: 20px;

  ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	li a {
		border: 6px solid #1a202c;
		padding: 10px 15px;
		text-decoration: none;
		color: #fff;
		display: block;
		display: flex;
		align-items: center;
		.icon {
			padding-right: 12px;
			font-size: 30px;
			color: #fff;
			transition: color 0.3s ease;
		}
		&:hover {
			border-left: 6px solid #03a9f4;
			.icon {
				color: #03a9f4;
			}
		}
		&.active {
			.icon {
				color: #03a9f4;
			}
		}
	}
`;
